const accessToken = `Bearer ${localStorage.getItem('jwt')}`
// const accessToken = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluMDFAZ21haWwuY29tIiwidXNlcklkIjoiNjM3NzRlZmRjZGVkZTk4NDJlNjg2NDQxIiwicm9sZSI6IlNVUEVSX0FETUlOIiwiaWF0IjoxNjY4NzY1ODQ3LCJleHAiOjE2Njg4NTIyNDd9.JCsQLlteW0cpvTayLh7XN3Fezg-B9QTtOT_6HeE5Gtw"
// console.log("side", localStorage.getItem('jwt'));
export default accessToken
